<template>
    <div>
        <div style="display:flex;flex-direction: row;justify-content: space-between">
            <div>
                <label>支付日期：</label>
               <a-range-picker
                    :ranges="{ Today: [moment(), moment()], 'This Month': [moment(), moment().endOf('month')] }"
                    @change="dateChange"
                    :format="dateFormat"
                    v-model="platdate"
                    style="width:200px"
                    />
            </div>
            <div>
                <label>驾校名称：</label>
                <a-select allowClear showSearch placeholder="请选择驾校" :filterOption="filterOption" style="width:180px" v-model="drivschid">
                <a-select-option
                    :value="item.value"
                    v-for="(item,idx) in drivschList"
                    :key="idx"
                >{{item.label}}</a-select-option>
                </a-select>
            </div>
            <div>
                <span class="span-duty">业务类型：</span>
                <a-select allowClear placeholder="请选择业务代码" style="width:180px" v-model="busicode">
                    <a-select-option value="6004">6004-合同终止</a-select-option>
                    <a-select-option value="6005">6005-学时上送</a-select-option>
                    <a-select-option value="6006">6006-学时撤销</a-select-option>
                    <a-select-option value="6007">6007-学时费用预支付</a-select-option>
                    <a-select-option value="6008">6008-科目一费用预支付</a-select-option>
                    <a-select-option value="6009">6009-合同退货</a-select-option>
                </a-select>
            </div>
        
        </div>
        <div style="text-align:center;margin-top:10px">
            <a-button
                type="primary"
                style="margin-left:16px;"
                @click="()=>{this.pagination.current = 1;fetch()}"
                >查询</a-button>
            <a-button v-if="btnPriviliges.btn_deal == '1'"
                type="primary"
                style="margin-left:16px;"
                @click="datedeal"
                >批量处理（日期）</a-button>
            <a-button v-if="btnPriviliges.btn_deal == '1'"
                type="primary"
                style="margin-left:16px;"
                @click="batchdeal"
                >批量处理（笔数）</a-button>
            
        </div>
        <Table
            :loading="loading"
            :rowKey='record => record.platssn'
            :tableColumns="columns"
            :tableData="tableData"
            :tablePagination="pagination"
            :noselect="noselect"
            v-on:onOrderbyChange="(newOrderby)=>{ orderby = newOrderby;fetch(); }"
            v-on:onPaginationChange="(newPagination)=>{ pagination = newPagination;fetch(); }"
            v-on:onBatch="(select)=>{ selected = select;flag='1' }"
           >
            <template v-slot="record">
                <div style="display:flex;flex-direction:row;justify-content:space-around;align-items:center">
                    <a v-if="btnPriviliges.btn_deal == '1'" @click="change(record)">调整</a>
                </div>
            </template>
        </Table>
    </div>
</template>
<script>
import Table from "../../components/Table"
import moment from "moment"
const columns = [
  {
    title: "请求日期",
    dataIndex: "reqdate",
    key: "reqdate",
    align: "center",
    width: 150,
    fixed: "left"
  },
  {
    title: "请求时间",
    dataIndex: "reqtime",
    key: "reqtime",
    align: "center",
    width: 150
  },
  {
    title: "付款单位",
    dataIndex: "drivschname",
    key: "drivschname",
    align: "center",
    width: 150
  },
  {
    title: "收款单位",
    dataIndex: "companyname",
    key: "companyname",
    align: "center",
    width: 150
  },
  {
    title: "付款账号",
    dataIndex: "accounno_out",
    key: "accounno_out",
    align: "center",
    width: 200
  },
  {
    title: "收款账号",
    dataIndex: "accounno_in",
    key: "accounno_in",
    align: "center",
    width: 200
  },
  {
    title: "业务类型",
    dataIndex: "busicode",
    key: "busicode",
    customRender: function(text) {
      return text == "6002"
        ? "驾校上送"
        : text == "6003"
        ? "合同报送"
        : text == "6004"
        ? "合同终止"
        : text == "6005"
        ? "学时报送"
        : text == "6006"
        ? "学时撤销"
        : text == "6007"
        ? "学时费用预支付"
        : text == "6008"
        ? "科目一费用预支付"
        : text == "6009"
        ? "合同退货"
        : text;
    },
    align: "center",
    width: 120
  },
  {
    title: "学科代码",
    dataIndex: "subjectid",
    key: "subjectid",
    align: "center",
    width: 100,
    customRender: function(text) {
      return text == "1"
        ? "科目一"
        : text == "2"
        ? "科目二"
        : text == "3"
        ? "科目三"
        : text == "4"
        ? "科目四"
        : text;
    }
  },
  {
    title: "本次上送学时",
    dataIndex: "classhour",
    key: "classhour",
    align: "center",
    width: 100
  },
  {
    title: "实际支付学时",
    dataIndex: "classhour_pay",
    key: "classhour_pay",
    align: "center",
    width: 100
  },
  {
    title: "溢出学时",
    dataIndex: "timesplil",
    key: "timesplil",
    align: "center",
    width: 100
  },
  {
    title: "支付金额",
    dataIndex: "amt",
    key: "amt",
    align: "center",
    width: 100,
    customRender: function(text) {
      if (!text) return "0.00";
      return parseFloat(text / 100).toFixed(2);
    }
  },
  {
    title: "支付状态",
    dataIndex: "paydtate",
    key: "paydtate",
    align: "center",
    customRender: function(text) {
      return text == "00"
        ? "未支付"
        : text == "01"
        ? "支付中"
        : text == "02"
        ? "支付成功"
        : text == "03"
        ? "支付失败"
        : text == "04"
        ? "支付异常"
        : text == "05"
        ? "无需支付"
        : text;
    },
    width: 120
  },
  {
    title: "支付状态码",
    dataIndex: "bkresp",
    key: "bkresp",
    align: "center",
  },
  {
    title: "支付状态描述",
    dataIndex: "bkrespdesc",
    key: "bkrespdesc",
    align: "center",
  },
  {
    title: "平台流水号",
    dataIndex: "platssn",
    key: "platssn",
    align: "center",
    width: 300
  },
  {
    title: "请求流水号",
    dataIndex: "joininstssn",
    key: "joininstssn",
    align: "center",
    width: 300
  },
  {
    title: "合同编号",
    dataIndex: "contno",
    key: "contno",
    align: "center",
    width: 200
  },
  {
    title: "支付发起日期",
    dataIndex: "paydate",
    key: "paydate",
    align: "center",
    width: 150
  },
  {
    title: "支付成功日期",
    dataIndex: "bkdate",
    key: "bkdate",
    align: "center",
    width: 150
  },
  {
    title: "撤销状态",
    dataIndex: "cancelst",
    key: "cancelst",
    align: "center",
    width: 170
  },
  {
    title: "撤销学时",
    dataIndex: "cancelhour",
    key: "cancelhour",
    align: "center",
    width: 100
  },
  {
    title: "撤销金额",
    dataIndex: "cancelamt",
    key: "cancelamt",
    align: "center",
    width: 100,
    customRender: function(text) {
      if (!text) return "0.00";
      return parseFloat(text / 100).toFixed(2);
    }
  },
  {
    title: "撤销交易平台流水",
    dataIndex: "cancelssn",
    key: "cancelssn",
    align: "center",
    width: 300
  },

  {
    title: "支付日期",
    dataIndex: "platdate",
    key: "platdate",
    align: "center",
    width: 150
  },
  {
    title: "操作",
    key: "operation",
    fixed: "right",
    align: "center",
    scopedSlots: { customRender: "operation" },
    width: 80
  }
];
export default {
    name: 'Financial',
    components:{
        Table
    },
    data(){
        return{
            drivasstid:this.$cache.session.get(this.$marco.constants.KEY_ORG_ID),
            drivschid:'',
            loading:false,
            columns,
            tableData:[],
            pagination:{
                current:1,
                total:0,
                pageSize:10,
                pageSizeOptions:['10','20','30','40','50']
            },
            orderby:'platssn desc',
            batchData:[],
            busicode: '',
            platdate:'',
            selected:[],
            batchData:[],
            flag:'',
            noselect:0,
            btnPriviliges:{},
            drivschList:[],
            dateFormat: "YYYY-MM-DD",
            platdate: [
                moment(moment().subtract(3,'days'), "YYYY-MM-DD"),
                moment(moment(), "YYYY-MM-DD")
            ],
            start_platdate: moment().subtract(3,'days').format('YYYYMMDD'),
            end_platdate:  moment().format('YYYYMMDD'),
        }
    },
    created(){
        const that = this;
        this.$btnAccess.getBtnByModule("/financial", data => {
        this.$log.success("按钮权限-----" + JSON.stringify(data));
        that.btnPriviliges = data;
        if (that.btnPriviliges["btn_deal"] != "1") {
            that.columns.pop();
        }
        });
        this.fetch();
        this.fetchDrivsch();
    },
    methods:{
        moment,
        dateChange(date, dateString) {
            this.start_platdate = dateString[0]
                ? moment(dateString[0]).format("YYYYMMDD")
                : "";
            this.end_platdate = dateString[1]
                ? moment(dateString[1]).format("YYYYMMDD")
                : "";
        },
        fetch(){
            const that = this;
            if(!that.start_platdate || !that.end_platdate){
                that.$message.error('请选择平台日期');
                return;
            }
            that.tableData = [];
            const reqData = {
                currpage: that.pagination.current,
                busicode: that.busicode,
                drivasstid: that.drivasstid,
                endDate: that.end_platdate,
                beginDate: that.start_platdate,
                drivschid:that.drivschid,
                orderby: that.orderby,
                recnumperpage: that.pagination.pageSize,
            }
            that.$http.post(
                that.$marco.api.abnormalTradeInfo,
                reqData,
                data => {
                    this.$log.success(JSON.stringify(data));
                    that.tableData = that.tableData.concat(data.pagelist);
                    that.pagination.total = data.recnum;
                },
                errorDesc => {
                    this.$log.normal(JSON.stringify(errorDesc));
                },
                error => {
                    this.$log.error(JSON.stringify(error));
                },
                that
            );
        },
        batchdeal(){
            this.$log.success(JSON.stringify(this.selected));
            this.batchData = [];
            this.selected.map((item)=>{
                this.batchData.push({"platssn":item});
            });
            if(this.batchData.length == 0){
              this.$message.error('请选择需要处理的交易');
              return ;
            }
            const reqData = {
                flag:1,
                unpaylist:this.batchData
            }
            this.$log.error(JSON.stringify(reqData));
            this.deal(reqData);
        },
        datedeal(){
            const reqData = {
                beginDate: that.start_platdate,
                endDate: that.end_platdate,
                flag:0,
            }
            if(this.start_platdate && this.end_platdate){
                this.deal(reqData);
            }
        },
        change(record){
            const reqData = {
                flag:1,
                unpaylist:[{platssn:record.platssn}]
            };
            this.deal(reqData);
        },
        deal(reqData){
            const that = this;
            that.$http.post(
                that.$marco.api.tradeInfoChange,
                reqData,
                data => {
                    that.$message.success('调整成功');
                    that.fetch();
                },
                errorDesc => {
                    this.$log.normal(JSON.stringify(errorDesc));
                },
                error => {
                    this.$log.error(JSON.stringify(error));
                },
                that
            );
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            );
        },
        fetchDrivsch(){
            const that = this;
            that.$http.post(
                that.$marco.api.schoolId,
                {drivasstid:that.drivasstid},
                data => {
                    this.$log.success('驾校列表'+JSON.stringify(data));
                    that.drivschList= [];
                    data.map((item)=>{
                        that.drivschList.push({
                            label:item.drivschname,
                            value:item.drivschid
                        })
                    })
                },
                errorDesc => {
                    this.$log.normal('驾协列表'+JSON.stringify(errorDesc));
                },
                error => {
                    this.$log.error('驾协列表'+JSON.stringify(error));
                },
                that
            );
        },
    }
}
</script>
<style>
</style>